<div class="loader-container" *ngIf="enabled">
  <div class="loader"></div>
</div>
